import { AttributeTypeEnum, useAttributeListQuery } from "@dashboard/graphql";
import { mapEdgesToItems } from "@dashboard/utils/maps";

/**
 * The store's own product attributes: what the series axis tick-boxes are built
 * from. Axes are stored as SLUGS, so this is the only place the slugs get their
 * merchant-facing names.
 *
 * ponytail: the Dashboard's existing attribute list query, first 100, no new
 * query document and no new field on the contract. Upgrade path if a store ever
 * passes 100 product attributes: page it here, or add a dedicated
 * `wsmSeriesAxisAttributes` field that returns only attributes a series can ask.
 */
export const useWsmAxisAttributes = () => {
  const { data, loading } = useAttributeListQuery({
    variables: { first: 100, filter: { type: AttributeTypeEnum.PRODUCT_TYPE } },
  });

  return { attributes: mapEdgesToItems(data?.attributes) ?? [], loading };
};

export default useWsmAxisAttributes;
